import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {User} from 'src/app/shared/models/user.model';
import {FormControl, FormGroup} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {ToolsService} from '../../shared/services/tools.service';
import {Router} from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    templateUrl: 'form-edit-user.html',
    selector: 'form-edit-user'
})

export class FormEditUserComponent implements OnInit, OnDestroy {

    @Input() user: User;

    accountForm: FormGroup;

    stateOptions: any = [];
    userLevelOptions: any = [];
    selectConfig: any = {
        labelField: 'label',
        valueField: 'value',
        searchField: ['value']
    };

    is_change = false;

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private dataStorageService: DataStorageService
        , private toolsService: ToolsService
        , private router: Router) {
    }

    ngOnInit(): void {

        this.stateOptions = this.toolsService.getStateOptions();
        this.userLevelOptions = this.toolsService.getUserLevelOptions();
        this.initForm();

        this.accountForm.get('is_change').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    this.is_change = value;
                }
            );
    }

    initForm() {
        this.accountForm = new FormGroup({
            'user_name': new FormControl(this.user.user_name),
            'agency_name': new FormControl(this.user.agency_name),
            'first_name': new FormControl(this.user.first_name),
            'last_name': new FormControl(this.user.last_name),
            'email': new FormControl(this.user.email),
            'phone': new FormControl(this.user.phone),
            'fax': new FormControl(this.user.fax),
            'address1': new FormControl(this.user.address1),
            'address2': new FormControl(this.user.address2),
            'city': new FormControl(this.user.city),
            'state': new FormControl(this.user.state),
            'zip': new FormControl(this.user.zip),
            'is_change': new FormControl(),
            'password': new FormControl(),
            'new-password': new FormControl(),
            'confirm-password': new FormControl(),
            'level': new FormControl(this.user.level),
            'is_active': new FormControl(this.user.is_active)
        });
    }

    onSubmit() {

        const value = this.accountForm.value;
        let newUser = new User(
            this.user.id, value.user_name, this.user.password, value.agency_name, value.last_name, value.first_name,
            value.address1, value.address2, value.city, value.state, value.zip,
            value.email, value.phone, value.fax,
            value.level, this.user.is_agree, value.is_active,
            this.user.last_logged_in, this.user.created);

        if (value['new-password']) {
            if (value['new-password'] === value['confirm-password']) {
                if (value['password'] === this.user.password) {
                    newUser.password = value['new-password'];
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } else {
            newUser.password = this.user.password;
        }

        this.dataStorageService.updateUser(newUser)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(responseData => {
                if (!responseData['error']) {
                    alert('user updated. ');
                    this.dataStorageService.fetchUserLists().subscribe();
                    this.router.navigate(['/pages/user']);
                }
            });

    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
